export const SET_WAIVERS_ERROR = 'SET_WAIVERS_ERROR';
export const SET_WAIVERS_LIST = 'SET_WAIVERS_LIST';
export const SET_TOTAL_AMOUNT_OF_WAIVERS = 'SET_TOTAL_AMOUNT_OF_WAIVERS';
export const SET_FETCHING_WAIVERS = 'SET_FETCHING_FINANCE';
